import { erpAxios } from '..';

const stepsDisabled = async (brojZahtjeva) => {
  const { data } = await erpAxios(`/loanApplication/stepsDisabled/${brojZahtjeva}`);
  return data;
};

export default stepsDisabled;
